import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { WindowState } from '@progress/kendo-angular-dialog';
import { FormGroup } from '@angular/forms';
import { User } from '@app/core/models';


@Component({
  selector: 'cancel-window',
  template: ``,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }
  `],
  providers: [ DatasourceService ] //Siempre hay que ponerlo en la clase que lo implemente.
})
export class CancelWindowComponent implements OnInit {

  //Inputs

  @Input() opened = false;  

  @Input() table: string = 'TABLE';

  @Input() label: string = 'LABEL';

  //Variables
  
  protected currentUser: User;
  
  protected windowState: WindowState = 'default';

  protected mode = 'CANCEL';

  protected form: FormGroup = null;  

  //Eventos

  // @Output() cancel: EventEmitter<any> = new EventEmitter();

  @Output() save: EventEmitter<{mode:string, dataItem:any}> = new EventEmitter();    

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {    

    this.authService.currentUser.subscribe(x => this.currentUser = x);

  }

  public getObjectString(dataItem: any): string {

    return [
      `Id: '${dataItem.id}'`
    ].join('\n')

  };

  protected getFormGroup(user: User, dataItem?: any): FormGroup {

    return new FormGroup({});

  };

  protected getData(formGroup: FormGroup): Object {

    return formGroup.value;

  };  

  public cancel(dataItem: any): void {
    
    this.mode = 'DELETE';

    this.alertService.confirmCancel(this.getObjectString(dataItem), () => {

      this.opened = true;
      this.form = this.getFormGroup(this.currentUser, dataItem);    
      // this.onSave(dataItem)

    });
    
  }

  public onSave(): void {
    
    let data: any = this.getData(this.form);
    // console.log('data', data)

    this.service.post(`${this.table}/${data.id}`, data) 
      .subscribe(
        (res) => {
          console.log("CANCEL Request is successful: ", this.table, data);
          // console.log("mode = " + this.mode);
          // this.save.emit({mode: this.mode, dataItem: res.data[0]});
          this.opened = false;
          // let msg = this.getObjectString(data)
          // this.alertService.showSuccess('Se canceló con éxito el recibo: ' + msg);
          this.save.emit({mode: this.mode, dataItem: res});

        },
        (fail) => {        
          console.log("Error", fail);
          // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
        }
      );

    // if(this.mode == 'CREATE'){
    //   this.service.addRow(this.table, data) 
    //     .subscribe(
    //       (res) => {
    //         console.log("POST Request is successful: ", this.table, data);
    //         console.log("mode = " + this.mode);
    //         this.save.emit({mode: this.mode, dataItem: res.data[0]});
    //         this.opened = false;
    //       },
    //       (fail) => {        
    //         console.log("Error", fail);
    //         // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
    //       }
    //     ); 
    // }
    // else {
    //   this.service.updateRow(this.table, data) 
    //     .subscribe(
    //       (res) => {
    //         console.log("PUT Request is successful: ", this.table, data);
    //         console.log("mode = " + this.mode);
    //         this.save.emit({mode: this.mode, dataItem: res.data[0]});
    //         this.opened = false;
    //       },
    //       (fail) => {        
    //         console.log("Error", fail);
    //         // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
    //       }
    //     ); 
    // }

  }

  // public cleanForm(formGroup: FormGroup) {
  //   Object.keys(formGroup.controls).forEach((key) => formGroup.get(key).setValue(formGroup.get(key).value.trim()));
  // }
  
  get f() { 
    
    return this.form.controls; 
  
  }

  public onClose(): void {

    this.opened = false;    

  }

  public onCancel(): void {

    this.opened = false;    

  }

  ngOnInit() {

    this.form = this.getFormGroup(this.currentUser);
    
  }

}
